export const examples = [
  // Example 1
  `// Roman Zhuravlov, TR-71, 2020

// Загальний приклад, що демонструє основні можливості розробленої мови Tyson:
// • Математичні вирази
// • Логічні вирази
// • Цикли for
// • Цикли while
// • Цикли do while

{
  let key = 123;
}

'single quote string';
"double quote string";

var integer = 123;
let double = 1.23;
const myVariable = 7;

for (let i = 1; i < 5; i += 1) {
  if (i === 1) {
    log(i +" turtle 🐢");
  }
  else if (i % 2 === 0) {
    log(i +" turtles 🐢");
  } else {
    log(i +" ducks 🦆");
  }
}

if (1 == 2) {
  key = 1;
}
else if (2 == 2) {
  key = 2;
}
else {
  key = 3;
}

log("Key = " + key);


let output = "";
let j = 0;

while (j <= 10) {
  if (j % 2 === 0) {
    output += "/";
  } else {
    output += "+";
  }
  j += 1;
}

log(output);
`,

  // Example 2
  `// Tyson підтримує числа, символьні рядки, логічні вирази
// та спеціальне значення null

'single quote string';
"double quote string";

1;
1.02;
 .03;

true;
false;

null;

// Для оголошення змінної використовується конструкція
// Type IdentName [= Exp];

let UndefinedVariable;

var integer = 123;
let double = 1.23;
const myVariable = true;

// Всі створені змінні відображаються у вкладці 'Парсер', в розділі 'Variables'
`,

  // Example 3
  `// Для виведення результатів коду на екран, використовується команда 'log'
// Log виводить значення переданого виразу в вкладку 'Парсер' та в консоль розробника (F12)
log(7 + 2 * (3 - 1));

// Операції оброблються логікаою Javascript,
// тому при додаванні чисел та строк підтримується динамічна типизація
log(21 + " test");

// Tyson підтримує строге та нестроге порівняння
log(3 === '3');
log(3 == '3');

log(5 !== '5');
log(5 != '5');

// Та логічні вирази, об'єднані командами || та &&
log(false || true);

let i = 2;

log(i >= 2 && i < 8);
log(i < 3 || i > 5);
`,

  // Example 4
  `// Цикли підтримуються командами for, while та do while
// На етапі перекладу коду в обернену польску нотацію, на місця умови виходу з циклів
// вставляються спецільні мітки формату #index, та спеціальні оператори $GoTo та $CondGoTo.
// Перелік створених міток та їх індекс в масиві токенів відображається у вкладці 'Парсер',
// в розділі 'Anchors'
for (let i = 0; i < 10; i += 1) {
  log(i % 5);
}

let output = "";
let j = 0;

do {
  if (j % 2 === 0) {
    output += "🙈";
  } else {
    output += "🙉";
  }
  j += 1;
} while (j <= 10);

log(output);
`,

  // Example 5
  `// Tyson підтримує логічні вирази
// В таблиці трансляції коду останнє значення змінної 'i' дорівнює 2
// Спробуйте змінити умову всередині дужок та оновити результати
let i = 0;

if (1 == 2) {
  i = 1;
}
else if (2 == 2) {
  i = 2;
}
else {
  i = 3;
}

log("I is equal to " + i);
`,

  // Example 6
  `// Створена реалізація транслятора має запобіжник від нескінченного циклу
// Наступний код завершиться після ста тисяч оброблених токенів,
// запобігаючи зависанню програми
let i = 0;

while(true) {
  i += 1;
}
`,

  // Example 7
  `// Якщо константній змінній спробувати змінити значення,
// або використати неоголошену змінну,
// виконання коду завершиться з помилкою

const i = false;
i = true;


if (i === undecliredValirable) {
  log("💀");
}
`,

  // Example 8
  `// Лексичні та синтаксичні помилки відображаються в вкладках 'Лексеми' та 'Синтаксис' відповідно
// В наступному прикладі пропущена закриваюча дужка
// Відповідне повідомлення виведено червоним кольором у вкладці 'Синтаксис'

let i = 2;


if (i === 3) {
  log("Seems like you missing a bracket");


log('This log is missing semicolon')

let 123Ident = "Ідентифікатори не можуть починатись з цифри";
`,
];
